<div class="app-loading-page">
  <app-empty-state [icon]="IconsEnum.more_horizontal" [loading]="true" theme="ghost" [title]="this.texts.general.loading"></app-empty-state>
</div>
